<template>
  <div class="procesar-envasado-producto container mt-4">
    <h3 class="text-success mb-4">
      <font-awesome-icon icon="box" class="me-2" />
      Envasar Producto Final Bulk
    </h3>

    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div v-else>
      <!-- Tarjeta del Producto Final Bulk -->
      <ProductoFinalCard :producto="producto" :producto_id="producto.id" />

      <form @submit.prevent="submitForm">

        <!-- Tipo Producto y Código -->
        <div class="mb-4 p-3 bg-light rounded border">
          <div class="row">
            <div class="col-md-6">
              <label class="fw-semibold text-secondary">Tipo de Producto</label>
              <input type="text" class="form-control" v-model="form.tipo_producto" readonly>
            </div>
            <div class="col-md-6">
              <label class="fw-semibold text-secondary">Código de Lote de Envasado</label>
              <input v-model="form.codigo" type="text" class="form-control" readonly placeholder="Generando...">
            </div>
          </div>
        </div>

        <!-- Tipo de Envase -->
        <div class="mb-4 p-3 bg-light rounded border">
          <label class="fw-semibold text-secondary">Tipo de Envase</label>
          <input type="text" v-model="envaseBuscar" class="form-control mb-2" placeholder="Buscar envase...">
          <select v-model="form.tipo_envase" class="form-select" required>
            <option value="">Seleccione tipo de envase</option>
            <option v-for="envase in envasesFiltrados" :key="envase.id" :value="envase.id">
              {{ envase.descripcion }}
            </option>
          </select>
        </div>

        <!-- Peso + Unidad + Cantidad + Precio -->
        <div class="row g-3 mb-4 p-3 bg-light rounded border">
          <div class="col-md-3">
            <label>Peso por Unidad</label>
            <input v-model.number="form.peso_por_unidad" type="number" class="form-control" step="0.1" min="0"
              @input="validarPesoTotal" placeholder="Ej: 1.0" required>
            <div class="mb-2 text-end text-muted small">
              Stock disponible: {{ producto.stockDisponible }} {{ form.unidad_medida_peso_envase }}
            </div>

          </div>


          <div class="col-md-3">
            <label>Unidad de Medida</label>
            <select v-model="form.unidad_medida_peso_envase" class="form-select" required disabled>
              <option value="">Seleccione unidad</option>
              <option v-for="unidad in unidadesMedida" :key="unidad" :value="unidad">
                {{ unidad }}
              </option>
            </select>
          </div>

          <div class="col-md-3">
            <label>Cantidad de Unidades</label>
            <input v-model.number="form.cantidad_unidades" min="1" type="number" class="form-control"
              @input="validarPesoTotal" required>
          </div>

          <div class="col-md-3">
            <label>Precio Unitario ({{ monedaActual.codigo }})</label>
            <input v-model.number="form.precio_unitario" type="number" step="0.01" min="0" class="form-control"
              placeholder="Ej: 10.50" required>
          </div>
        </div>

        <!-- Fechas -->
        <div class="row g-3 mb-4 p-3 bg-light rounded border">
          <h6 class="text-primary">Vencimiento</h6>

          <div class="col-md-4">
            <label>Fecha de Envasado</label>
            <input v-model="form.fecha_envasado" type="date" class="form-control" required
              @input="calcularFechaVencimiento">
          </div>

          <div class="col-md-4">
            <label>Días hasta Vencimiento</label>
            <input v-model.number="form.dias_vencimiento" min="0" type="number" class="form-control"
              @input="calcularFechaVencimiento">
          </div>

          <div class="col-md-4">
            <label>Fecha de Vencimiento</label>
            <input v-model="form.fecha_vencimiento" type="date" class="form-control" @input="calcularDiasVencimiento">
          </div>
        </div>

        <!-- Observaciones -->
        <div class="mb-4">
          <label>Observaciones</label>
          <textarea v-model="form.observaciones" class="form-control" rows="3"></textarea>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-outline-secondary" @click="$emit('cancelar')">Cancelar</button>
          <button type="submit" class="btn btn-success">Registrar Envasado</button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import ProductoFinalCard from "./ProductoFinalCard.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'ProcesarEnvasadoProductoFinal',
  components: { FontAwesomeIcon, ProductoFinalCard },
  props: {
    producto: { type: Object, required: true }
  },
  data() {
    const hoy = new Date().toISOString().substr(0, 10);
    return {
      tiposEnvases: [],
      unidadesMedida: [],
      monedaActual: {},
      envaseBuscar: '',
      loading: true,
      form: {
        tipo_envase: '',
        tipo_producto: this.producto.tipo_producto,
        peso_por_unidad: null,
        unidad_medida_peso_envase: '',
        cantidad_unidades: null,
        precio_unitario: null,
        tipo_moneda: '', // Se asigna al obtener moneda actual
        fecha_envasado: hoy,
        dias_vencimiento: null,
        fecha_vencimiento: '',
        codigo: '',
        observaciones: ''
      },
      clubActual: this.$store.getters.getClubActual
    };
  },
  computed: {
    envasesFiltrados() {
      return this.tiposEnvases.filter(envase =>
        envase.descripcion.toLowerCase().includes(this.envaseBuscar.toLowerCase())
      );
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {

        
        const [envases, unidades, codigoLote, moneda] = await Promise.all([
          axios.get('/api/constantes/tipos_de_envases'),
          axios.get('/api/constantes/unidades-medida'),
          axios.get('/api/producto_final_envasado_generar_codigo', {
            params: { club_id: this.clubActual.id, producto_final_bulk_id: this.producto.id }
          }),
          
          axios.get('/api/moneda_actual', { params: { club_id: this.clubActual.id } })
        ]);
        this.tiposEnvases = envases.data;
        this.unidadesMedida = unidades.data;
        //seleccionar unidad de medida igual a la del producto
        this.form.unidad_medida_peso_envase = this.producto.unidad_medida;
        this.monedaActual = moneda.data;
        this.form.codigo = codigoLote.data.codigo;

        this.form.tipo_moneda = moneda.data.codigo;

      } catch (error) {
        console.error("Error al cargar datos:", error);
        alert("Error al cargar datos iniciales.");
      } finally {
        this.loading = false;
      }
    },

    validarPesoTotal() {
      const total = this.form.peso_por_unidad * this.form.cantidad_unidades;
      const totalAjustado = parseFloat(total.toFixed(1));
      const stockDisponible = this.producto.stockDisponible;

      if (totalAjustado > stockDisponible) {
        alert(`El peso total (${totalAjustado} ${this.form.unidad_medida_peso_envase}) excede el stock disponible (${stockDisponible} ${this.form.unidad_medida_peso_envase}).`);
        this.form.cantidad_unidades = null;
      }
    }
    ,

    calcularFechaVencimiento() {
      if (this.form.fecha_envasado && this.form.dias_vencimiento !== null) {
        const fecha = new Date(this.form.fecha_envasado);
        fecha.setDate(fecha.getDate() + this.form.dias_vencimiento);
        this.form.fecha_vencimiento = fecha.toISOString().substr(0, 10);
      }
    },

    calcularDiasVencimiento() {
      if (this.form.fecha_envasado && this.form.fecha_vencimiento) {
        const fechaEnvasado = new Date(this.form.fecha_envasado);
        const fechaVencimiento = new Date(this.form.fecha_vencimiento);
        const diffTime = fechaVencimiento - fechaEnvasado;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        this.form.dias_vencimiento = diffDays;
      }
    },

    async submitForm() {
      const pesoTotal = this.form.peso_por_unidad * this.form.cantidad_unidades;
      const stockDisponible = this.producto.stockDisponible;

      if (pesoTotal > stockDisponible) {
        alert("No se puede registrar el envasado: el peso total excede el stock disponible.");
        return;
      }

      try {
        await axios.post('/api/producto_final_envasado', {
          producto_final_bulk_id: this.producto.id,
          club_id: this.clubActual.id,
          ...this.form,
          fecha_envasado: new Date(this.form.fecha_envasado),
          fecha_vencimiento: new Date(this.form.fecha_vencimiento)
        });
        alert('Envasado registrado correctamente.');
        this.$emit('envasadoFinalizado');
      } catch (error) {
        console.error('Error al registrar envasado:', error);
        alert('Error al registrar envasado');
      }
    }

  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.procesar-envasado-producto {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
}

.card {
  background-color: #f8f9fa;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.fw-semibold {
  font-weight: 600;
}
</style>
